import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, AbstractControl } from "@angular/forms";
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationSteps } from "../../../../../applications/models/applications.models";
import { AuthService } from "../../../../../services/auth.service";
import { IUploadFile } from '../../../../../common/services/document-management.service';

@Component({
    selector: 'plat-documentation',
    templateUrl: './plat-documentation.component.html',
    styleUrls: ['./plat-documentation.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class PlatDocumentationComponent extends ApplicationSectionBaseComponent implements OnInit {

    readonly step: ApplicationSteps = ApplicationSteps.Documentation;

    get boreholeDeviationCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('boreholeDeviationSurvey');
    }

    get boreholeDeviationFiles(): IUploadFile[] {
        if (this.finalPlatCtrl == null) return [];
        return <IUploadFile[]>this.boreholeDeviationCtrl.value;
    }

    get finalPlatCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('finalAsDrilledPlat');
    }

    get finalPlatFiles(): IUploadFile[] {
        if (this.finalPlatCtrl == null) return [];
        return <IUploadFile[]>this.finalPlatCtrl.value;
    }

    get preliminaryPlatCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('preliminaryPlat');
    }

    get preliminaryPlatFiles(): IUploadFile[] {
        if (this.finalPlatCtrl == null) return [];
        return <IUploadFile[]>this.preliminaryPlatCtrl.value;
    }

    get revisedUnitCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('revisedUnitPlat');
    }

    get revisedUnitFiles(): IUploadFile[] {
        if (this.finalPlatCtrl == null) return [];
        return <IUploadFile[]>this.revisedUnitCtrl.value;
    }

    get royaltyCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('royaltyInterestList');
    }

    get royaltyFiles(): IUploadFile[] {
        if (this.finalPlatCtrl == null) return [];
        return <IUploadFile[]>this.royaltyCtrl.value;
    }

    constructor(auth: AuthService) {
        super(auth);
    }

    ngOnInit() {
    }

    boreholeFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.boreholeDeviationFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Borehole Deviation Survey";
            files.push(evt);
            this.boreholeDeviationCtrl.setValue(files);
        }
    }

    boreholeFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.boreholeDeviationFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.boreholeDeviationCtrl.setValue(files);
        }
    }

    finalPlatFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.finalPlatFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Plat Maps Final";
            files.push(evt);
            this.finalPlatCtrl.setValue(files);
        }
    }

    finalPlatFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.finalPlatFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.finalPlatCtrl.setValue(files);
        }
    }

    preliminaryPlatFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.preliminaryPlatFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Plat As Drilled";
            files.push(evt);
            this.preliminaryPlatCtrl.setValue(files);
        }
    }

    preliminaryPlatFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.preliminaryPlatFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.preliminaryPlatCtrl.setValue(files);
        }
    }

    revisedPlatFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.revisedUnitFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Plat Maps Revised";
            files.push(evt);
            this.revisedUnitCtrl.setValue(files);
        }
    }

    revisedPlatFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.revisedUnitFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.revisedUnitCtrl.setValue(files);
        }
    }

    royaltyFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.royaltyFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Royalty Interest Listing";
            files.push(evt);
            this.royaltyCtrl.setValue(files);
        }
    }

    royaltyFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.royaltyFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.royaltyCtrl.setValue(files);
        }
    }


    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }
}
